<template>
  <v-dialog v-model="displayFlag" width="500" persistent>
    <v-card>
      <v-card-title class="headline red white--text" primary-title>
        {{ $vuetify.t('$vuetify.calls.editPowraHeader') }}
      </v-card-title>
      <v-card-text>
        {{ $vuetify.t('$vuetify.calls.editPowraBody') }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" flat @click.native="displayFlag = false">
          {{ $vuetify.t('$vuetify.app.cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="confirmEditPowra">
          {{ $vuetify.t('$vuetify.calls.editPowraConfirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import formatting from '../mixins/formatting.js'

export default {
  name: 'EditPowraDialog',
  mixins: [formatting],
  data: () => ({
    displayFlag: false
  }),
  mounted() {},
  methods: {
    show: function() {
      this.displayFlag = true
    },
    hide: function() {
      this.displayFlag = false
    },
    confirmEditPowra: function() {
      this.$emit('accept-edit-powra-warning')
    }
  },
  computed: {}
}
</script>
